import theme from '@styles/theme';
export default {
  headerWithText: (bg: string, color: string) => ({
    bg,
    textAlign: 'center',
    padding: ['64px 40px', '64px 40px', '80px 64px', '6.04166667vw 64px'],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    p: {
      color,
      maxWidth: 756,
      width: '100%',
      pb: 24
    }
  })
};